import {useEffect} from 'react'
import {Column} from 'react-table'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {formatDate} from '../../../../../../util/dates'
import {GuestFileModel, GuestFileDetailModel} from '../../model'
import {getOpaGuestFileDetailService} from '../../service/bookingInt'

const TableUploadGuestDetails = ({bookingToShow}: PropsA) => {
  const {data, setData, setPagination, loading, setLoading, pagination} = useKTable()
  const getUploadBookingsDetail = async (bandejaId: string) => {
    try {
      setLoading(true)
      const {data: response} = await getOpaGuestFileDetailService(
        {
          bandejaId: bandejaId,
        },
        pagination.currentPage,
      )
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getUploadBookingsDetail(bookingToShow.id as any)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  const columns: Column<GuestFileDetailModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nro de Fila' size='50px' />,
      accessor: 'nroFila',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Documento' />,
      accessor: 'tipoDocumentoNombre',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Número de Documento' />,
      accessor: 'numeroDocumento',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo Doc. Trabajador' />,
      accessor: 'tipoDocumentoTrabajadorNombre',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Número Doc. Trabajador' />,
      accessor: 'numeroDocumentoTrabajador',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nombres' />,
      accessor: 'nombres',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Apellido Paterno' />,
      accessor: 'apPaterno',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Apellido Materno' />,
      accessor: 'apMaterno',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='RUC Empresa Subcontratista' />,
      accessor: 'rucEmpresaSubcontratista',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Razón Social Subcontratista' />,
      accessor: 'razonSocialSubcontratista',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cargo' />,
      accessor: 'cargo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='RUC Empresa Contratante' />,
      accessor: 'rucEmpresaContratante',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Estadi' />,
      accessor: 'estado',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Sexo' />,
      accessor: 'sexo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Teléfono Persona' />,
      accessor: 'telefonoPersona',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Sexo' />,
      accessor: 'emailPersona',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Teléfono Persona' />,
      accessor: 'telefonoEmpresa',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Sexo' />,
      accessor: 'ubigeoEmpresa',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Teléfono Persona' />,
      accessor: 'tipoEstadia',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Sexo' />,
      accessor: 'tipoHuesped',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha de Ingreso' size='200px' />,
      accessor: 'fechaTentativaIngreso',
      Cell: ({...props}) => <div>{formatDate(props.row.original.fechaTentativaIngreso)}</div>,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Observaciones' size='400px' />,
      accessor: 'observaciones',
      Cell: ({...props}) => (
        <div>
          {props.row.original.observaciones?.split('\n')?.map((line, index) => (
            <div key={index}>{line}</div>
          ))}
        </div>
      ),
    },
  ]

  useEffect(() => {
    // setLoading(loading)
    setLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  return (
    <>
      <KTCard shadow className='m-5'>
        <KTable data={data} columns={columns} />
        {loading ? <KTableLoading title='Cargando...' /> : null}
      </KTCard>
    </>
  )
}

interface PropsA {
  bookingToShow: GuestFileModel
}

const TableUploadGuestShowDetailsWrapper = ({bookingToShow}: PropsA) => {
  return (
    <KTableProvider>
      <TableUploadGuestDetails bookingToShow={bookingToShow} />
    </KTableProvider>
  )
}

export {TableUploadGuestShowDetailsWrapper}
